<template>

    <div>

        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->

        <v-col align="center">
            <v-text-field class="centered-input" v-model="search" append-icon="search" label="Search Module" single-line
                hide-details style="width: 50%;"></v-text-field>
        </v-col>
        <v-row dense>
            <v-col sm="3" md="3" v-for="linkname in filteredSortSearchList" :key="linkname.name" :cols="linkname.flex">
                <router-link :to="{ name: linkname.name}" style="text-decoration: none;">
                    <v-card :elevation="2" class="card compact-card d-flex flex-column">
                        <div class="flex-grow-1 d-flex flex-column align-center justify-center">
                            <v-avatar color="#2c3e50" size="48" class="mb-2">
                            <v-icon size="32" class="link-icon">{{ linkname.icon }}</v-icon>
                            </v-avatar>
                            <strong class="linkname text-center">{{ linkname.textval }}</strong>
                        </div>

                        <v-card-actions class="compact-actions">
                            <v-avatar v-if="linkname.size == 0" color="red darken-1" size="24"><span class="white--text text-caption">{{ linkname.size }}</span></v-avatar>
                            <v-avatar v-else color="#2c3e50" size="24"><span class="white--text text-caption">{{ linkname.size }}</span></v-avatar>
                            <v-spacer />
                            <router-link :to="{ name: linkname.name }" style="text-decoration: none;">
                            <v-btn icon x-small><v-icon size="22" color="#2c3e50">mdi-plus-circle</v-icon></v-btn>
                            </router-link>
                        </v-card-actions>
                    </v-card>
                </router-link>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios'

import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed


export default {
    components: {
        Breadcrumbs,
    },
  data() {
    return {
      routerLinkList: [],
        search: '',
        // extraBreadcrumbItems: [

        // ],
        // breadcrumbClass: "breadcrumb-style1", // Default style,
       
    };
    }, // end of data()
    
  mounted(){
       axios.get("SelfAppriasalMaster/appriasalMasterMenu")
    .then(res =>{
      //window.console.log("res"+res.data)
      if(res.data.msg=="200"){
        this.data = res.data
        this.routerLinkList=res.data.routerLinkList
        //console.log(this.data)  
      }
      else{
      }
    })
    .catch(error => {
        window.console.log(error)
    })

    },
  /**
   * 
   */
  
    
  computed: {
    
    filteredSortSearchList(){
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }
      if (!this.search) return this.routerLinkList.sort(compare);
      
      return this.routerLinkList.filter(tbdata=>{
          return tbdata.name.toLowerCase().indexOf(this.search.toLowerCase())>=0       
      })
    }
  } // end of computed()

};
</script>
<style scoped>
    /* .card-title {
        font-weight: 400;
        color: #9e9e9e;
    }
    .add-plus-icon {
        color: #616161;
    }
    .avatar-icon {
        border: 1px solid #0000001a;
    }
    .link-icon {
        color: #bdbdbd;
    }
    #card-hover {
        transition: cubic-bezier(0.895, 0.03, 0.685, 0.22);
    }
    #card-hover:hover {
        background: #ededed;
    }
    #card-hover:hover .link-icon {
        color: #3f51b5;
    }
    #card-hover:hover .avatar-icon {
        border-color: #3f51b5;
        background: white;
    }
    #card-hover:hover .card-title {
        color: #777777;
    }
    #card-hover:hover .add-plus-icon {
        border: none;
        border-radius: 100%;
        color: white;
        background: #3f51b5;
    } */
    .card {
       border: #2c3e50 !important;
    }
    .card:hover {
        background: #bdc3c7; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, var(--v-brand-base), var(--v-brandLight-base)); /* Chrome 10-25, Safari 5.1-6 */
        background: var(--v-brand-base); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        color: white !important;
        font-weight: bold !important;
        text-align: center;
        box-shadow: 20px 20px 20px grey !important;
        -webkit-transition:  box-shadow  0.3s ease-in !important;
    }
    .compact-card {
        min-height: 170px;
        padding: 8px;
        border-radius: 16px !important;
    }

    .compact-actions {
        padding: 4px 8px;
    }
    .link-icon {
        color: white;
    }
    .add-plus-icon:hover {
        color: white;
    }

    linkname {
        color: #2c5364 !important;
    }
         .breadcrumb {
    
             padding: 2px;
             margin-left: 60px;
             margin-top: -55px;
             font-size: medium;
             font-weight: bold;
         }
</style>